import { createNode, DurationDataType } from '@glueapp/graph-types';
import { toDuration, fromDuration } from '../../utils/temporal';

export const NegateDuration = createNode({
    id: 'Negate Duration',
    name: 'Negate Duration',
    description: 'Negates a Duration, flipping the sign of all components',
    aiDescription: 'Takes a Duration on the "Duration" port and outputs a Duration with all components negated on the "Result" port.',
    category: 'Date & Time',
    color: '#3b82f6',
    integration: undefined,
    inPorts: {
        Duration: DurationDataType,
    },
    outPorts: {
        Result: DurationDataType,
    },
    execute: function (input) {
        const duration = toDuration(input.inPorts.Duration);
        const result = duration.negated();
        return { output: { Result: fromDuration(result) } };
    },
});
